export default __webpack_public_path__ + "static/media/WAS0420.34I-39841_-23878_0.4381aed6.jpg";